var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Typography } from '@material-ui/core';
var DynamicText = /** @class */ (function (_super) {
    __extends(DynamicText, _super);
    function DynamicText() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._until = new Subject();
        return _this;
    }
    DynamicText.prototype.componentDidMount = function () {
        var _this = this;
        this.props.dataState.pathChange
            .pipe(takeUntil(this._until), filter(function (event) { return event.sender != _this; }))
            .subscribe(function () { return _this.forceUpdate(); });
    };
    DynamicText.prototype.componentWillUnmount = function () {
        this._until.next();
        this._until.complete();
    };
    DynamicText.prototype.render = function () {
        if (this.props.control.text) {
            return React.createElement(Typography, { variant: this.props.control.variant }, this.props.dataState.compilePattern(this.props.control.text));
        }
        else {
            return React.createElement(Typography, { variant: this.props.control.variant }, this.props.dataState.compilePattern(this.props.control.path));
        }
    };
    return DynamicText;
}(React.Component));
export default DynamicText;
//# sourceMappingURL=Text.js.map